import ModalModule from "../../../components/UI/modal/ModalModule";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import MenuItem from "@mui/material/MenuItem";
import React, {useMemo, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {SideBaseModule} from "../../../data/SideBaseModule";
import {Box} from "@mui/system";
import ModuleController from "../../../API/organization/ModuleController";
import CompositionController from "../../../API/organization/CompositionController";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {Typography} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {HeightLocationModule} from "../../../data/HeightLocationModule";
import {flattenModuleCompositionRow} from "../../../utils/flattenModuleCompositionRow";
import {withCompositionIdQuery} from "../../../utils/withCompositionIdQuery";
import {comparePriority} from "../../../utils/comparePriority";
import OverflowTooltip from "../../../components/UI/tooltip/OverflowTooltip";

const PRIORITY_COL_WIDTH = 160

const DMC_MODAL_COL_WIDTHS = {
    priority: PRIORITY_COL_WIDTH,
    heightLocation: 260,
    width: 200,
    height: 200,
    depth: 210,
}

const DMC_MODAL_FIXED_COLS_WIDTH = Object.values(DMC_MODAL_COL_WIDTHS).reduce((sum, width) => sum + width, 0)
const DMC_MODAL_CHROME_WIDTH = 120
const DMC_MODAL_NAME_WIDTH = `calc(100vw - ${DMC_MODAL_CHROME_WIDTH}px - ${DMC_MODAL_FIXED_COLS_WIDTH}px)`
const DMC_MODAL_TABLE_WIDTH = `calc(${DMC_MODAL_FIXED_COLS_WIDTH}px + ${DMC_MODAL_NAME_WIDTH})`

const EMBEDDED_MODULE_COLUMN_KEYS = new Set(['name', 'width', 'height', 'depth']);

const EMBEDDED_MODULE_ROW_ACTIONS_WIDTH = 50
const EMBEDDED_MODULE_NAME_TO_DIM_RATIO = 1.35
const EMBEDDED_MODULE_FALLBACK_TABLE_WIDTH = 880

const getEmbeddedModuleTableLayout = (tableWidth) => {
    const available = Math.max(tableWidth - EMBEDDED_MODULE_ROW_ACTIONS_WIDTH, 320)
    const dimWidth = Math.floor(available / (3 + EMBEDDED_MODULE_NAME_TO_DIM_RATIO))
    const nameWidth = available - dimWidth * 3
    const colWidths = {
        name: nameWidth,
        width: dimWidth,
        height: dimWidth,
        depth: dimWidth,
    }

    return {
        tableWidth: EMBEDDED_MODULE_ROW_ACTIONS_WIDTH + nameWidth + dimWidth * 3,
        colWidths,
    }
}

const compactEmbeddedColSx = (columnId, colWidths) => {
    const width = colWidths?.[columnId]
    if (width == null) {
        return {}
    }
    return {
        width,
        minWidth: width,
        maxWidth: width,
        boxSizing: 'border-box',
        ...(columnId === 'name' ? {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        } : {
            whiteSpace: 'nowrap',
        }),
    }
}

const dmcModalFilterFieldProps = {
    sx: {
        width: '100%',
        minWidth: 0,
        '& .MuiInputBase-root': {
            width: '100%',
        },
    },
}

const dmcModalColSx = (columnId) => {
    if (columnId === 'name') {
        return {
            width: DMC_MODAL_NAME_WIDTH,
            minWidth: DMC_MODAL_NAME_WIDTH,
            maxWidth: DMC_MODAL_NAME_WIDTH,
            flex: `0 0 ${DMC_MODAL_NAME_WIDTH}`,
            boxSizing: 'border-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }
    }
    const width = DMC_MODAL_COL_WIDTHS[columnId]
    if (width == null) {
        return {}
    }
    return {
        width,
        minWidth: width,
        maxWidth: width,
        flex: `0 0 ${width}px`,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
    }
}

const ModulesTable = ({
                          moduleId,
                          dependentModuleCompositionId,
                          compositionId,
                          moduleName,
                          compactEmbeddedModules,
                          embeddedModulesTableWidth,
                          handleModalAlert,
                          data,
                          setData,
                          tableOptions,
                          tableOptionsHandle,
                          isModal,
                          selectedString,
                          setSelectedString,
                          globalFilter,
                          handleSearchQuery,
                          filteredData,
                          columnsFilter,
                      }) => {
    const sideBaseModuleList = Object.entries(SideBaseModule)
    const heightLocationModuleList = Object.entries(HeightLocationModule)

    const initValue = {
        "name": "",
        "groupName": "",
        "sideBaseModule": sideBaseModuleList[0][0],
        "heightLocation": heightLocationModuleList[0][0],
        "width": 150,
        "height": 750,
        "depth": 300,
        "minWidth": 150,
        "minHeight": 750,
        "minDepth": 300,
        "maxWidth": 1200,
        "maxHeight": 1200,
        "maxDepth": 600
    }

    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [loading, setLoading] = useState(false)
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }

    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(initValue)
    }

    const handleUpdate = (value, submit) => {
        setLoading(true)
        const {id, ...rest} = value
        
        ModuleController.update(replaceEmptyStringsOnNull(rest), id)
            .then(function (response) {
                const newData = data.map(el => el.id === response.data.id ? response.data : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                submit()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleSubmit = (value, submit) => {
        setLoading(true)
        ModuleController.save(replaceEmptyStringsOnNull(value))
            .then(function (response) {
                const newData = [...data, response.data]
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                submit()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleSubmitDepend = (id, submit) => {
        setLoading(true)
        const request = dependentModuleCompositionId
            ? CompositionController.addDependentModuleComposition(dependentModuleCompositionId, id)
            : ModuleController.addDepend(moduleId, id)
        request.then(function (response) {
                const added = response?.data
                const row = added == null
                    ? null
                    : (dependentModuleCompositionId ? flattenModuleCompositionRow(added) : added)
                const newData = row == null ? data : [...data, row]
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                submit()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleAdd = () => {
        setModal(true)
    }
    const handleEdit = (row) => {
        setCurrentEditRowData(row);
        setModal(true)
    };
    const handleDelete = (row) => {
        ModuleController.delete(row.id).then(function () {
            const newData = data.filter(el => el.id !== row.id)
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleModalAlert("Данные удалены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const embeddedTableLayout = useMemo(() => {
        if (!compactEmbeddedModules) {
            return null
        }
        return getEmbeddedModuleTableLayout(embeddedModulesTableWidth ?? EMBEDDED_MODULE_FALLBACK_TABLE_WIDTH)
    }, [compactEmbeddedModules, embeddedModulesTableWidth])

    const columns = useMemo(() => {
        if (dependentModuleCompositionId) {
            return [
                {
                    id: 'priority',
                    header: 'Приоритет',
                    accessorKey: 'priority',
                    size: DMC_MODAL_COL_WIDTHS.priority,
                    minSize: DMC_MODAL_COL_WIDTHS.priority,
                    maxSize: DMC_MODAL_COL_WIDTHS.priority,
                    grow: false,
                    enableResizing: false,
                    muiFilterTextFieldProps: dmcModalFilterFieldProps,
                    sortingFn: (rowA, rowB) => comparePriority(rowA.original.priority, rowB.original.priority),
                },
                {
                    id: 'name',
                    header: 'Наименование',
                    accessorKey: 'name',
                    grow: false,
                    enableResizing: false,
                    muiFilterTextFieldProps: dmcModalFilterFieldProps,
                    Cell: ({row, renderedCellValue}) => (
                        <OverflowTooltip title={row.original.name}>
                            {renderedCellValue}
                        </OverflowTooltip>
                    ),
                },
                {
                    id: 'heightLocation',
                    header: 'Расположение',
                    accessorKey: 'heightLocation',
                    size: DMC_MODAL_COL_WIDTHS.heightLocation,
                    minSize: DMC_MODAL_COL_WIDTHS.heightLocation,
                    maxSize: DMC_MODAL_COL_WIDTHS.heightLocation,
                    grow: false,
                    enableResizing: false,
                    muiFilterTextFieldProps: dmcModalFilterFieldProps,
                    Cell: ({cell}) => HeightLocationModule[cell.getValue()] ?? '',
                },
                {
                    id: 'width',
                    header: 'Ширина',
                    accessorKey: 'width',
                    size: DMC_MODAL_COL_WIDTHS.width,
                    minSize: DMC_MODAL_COL_WIDTHS.width,
                    maxSize: DMC_MODAL_COL_WIDTHS.width,
                    grow: false,
                    enableResizing: false,
                    muiFilterTextFieldProps: dmcModalFilterFieldProps,
                },
                {
                    id: 'height',
                    header: 'Высота',
                    accessorKey: 'height',
                    size: DMC_MODAL_COL_WIDTHS.height,
                    minSize: DMC_MODAL_COL_WIDTHS.height,
                    maxSize: DMC_MODAL_COL_WIDTHS.height,
                    grow: false,
                    enableResizing: false,
                    muiFilterTextFieldProps: dmcModalFilterFieldProps,
                },
                {
                    id: 'depth',
                    header: 'Глубина',
                    accessorKey: 'depth',
                    size: DMC_MODAL_COL_WIDTHS.depth,
                    minSize: DMC_MODAL_COL_WIDTHS.depth,
                    maxSize: DMC_MODAL_COL_WIDTHS.depth,
                    grow: false,
                    enableResizing: false,
                    muiFilterTextFieldProps: dmcModalFilterFieldProps,
                },
            ]
        }
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'name', minSize: 150,
                Cell: ({cell, row}) => (
                    <li key={cell.getValue()}>
                        <Link
                            to={dependentModuleCompositionId
                                ? withCompositionIdQuery('/organization/module-composition/' + row.original.id, compositionId)
                                : moduleId
                                    ? '/organization/module/' + row.original.id + "/depend/" + moduleId + "/" + encodeURIComponent(moduleName ?? "")
                                    : '/organization/module/' + row.original.id}
                        >{row.original.name}</Link>
                    </li>
                ),
            },
            {
                header: 'Группа', accessorKey: 'groupName', minSize: 15, maxSize: 15,
            },
            {
                header: 'Расположение', accessorKey: 'sideBaseModule', minSize: 15, maxSize: 15,
                Cell: ({cell}) => SideBaseModule[cell.getValue()],
            },
            {
                header: 'Расположение (по высоте)', accessorKey: 'heightLocation', minSize: 15, maxSize: 15,
                Cell: ({cell}) => HeightLocationModule[cell.getValue()],
            },
            {
                header: 'Ширина', accessorKey: 'width', minSize: 15, maxSize: 15,
            },
            {
                header: 'Высота', accessorKey: 'height', minSize: 15, maxSize: 15,
            },
            {
                header: 'Глубина', accessorKey: 'depth', minSize: 15, maxSize: 15,
            },
            {
                header: 'Мин. ширина', accessorKey: 'minWidth', minSize: 15, maxSize: 15,
            },
            {
                header: 'Мин. высота', accessorKey: 'minHeight', minSize: 15, maxSize: 15,
            },
            {
                header: 'Мин. глубна', accessorKey: 'minDepth', minSize: 15, maxSize: 15,
            },
            {
                header: 'Макс. ширина', accessorKey: 'maxWidth', minSize: 15, maxSize: 15,
            },
            {
                header: 'Макс. высота', accessorKey: 'maxHeight', minSize: 15, maxSize: 15,
            },
            {
                header: 'Макс. глубна', accessorKey: 'maxDepth', minSize: 15, maxSize: 15,
            },
        ]

        if (compactEmbeddedModules && embeddedTableLayout) {
            const {colWidths} = embeddedTableLayout
            const nameColumn = baseColumns.find((column) => column.accessorKey === 'name')
            const dimensionColumns = ['width', 'height', 'depth'].map((accessorKey) => {
                const column = baseColumns.find((item) => item.accessorKey === accessorKey)
                const width = colWidths[accessorKey]
                return {
                    ...column,
                    id: accessorKey,
                    size: width,
                    minSize: width,
                    maxSize: width,
                    grow: false,
                    enableResizing: false,
                }
            })

            return [
                {
                    ...nameColumn,
                    id: 'name',
                    size: colWidths.name,
                    minSize: colWidths.name,
                    maxSize: colWidths.name,
                    grow: false,
                    enableResizing: false,
                },
                ...dimensionColumns,
            ]
        }

        return baseColumns;

    }, [data, filteredData, moduleId, moduleName, dependentModuleCompositionId, compositionId, compactEmbeddedModules, embeddedTableLayout]);

    const menuItem = dependentModuleCompositionId ? [] : moduleId ? [
        {type: "delete", text: "Удалить", handler: handleDelete},
    ] : [
        {type: "edit", text: "Редактировать", handler: handleEdit},
        {type: "delete", text: "Удалить", handler: handleDelete},
    ]
    const embeddedTableWidth = embeddedTableLayout?.tableWidth
    const tableWidth = compactEmbeddedModules
        ? embeddedTableWidth
        : dependentModuleCompositionId
            ? DMC_MODAL_TABLE_WIDTH
            : (isModal ? '100%' : '2220px')

    return (<Box sx={{
        display: 'flex', flexDirection: "column", overflow: 'auto',
        width: isModal ? "100%" : (compactEmbeddedModules ? embeddedTableWidth : undefined),
        maxWidth: isModal ? "100%" : (compactEmbeddedModules ? embeddedTableWidth : "2220px"),
        minWidth: isModal ? 0 : undefined,
    }}>
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
        >
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>{!moduleId && !isModal && "Модули"}</Typography>
            {!isModal && <ButtonCreate
                text={"Добавить"}
                width={130}
                onClick={handleAdd}
            />}
        </Box>
        <MaterialReactTable
            layoutMode={dependentModuleCompositionId ? "grid" : undefined}
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    width: compactEmbeddedModules ? embeddedTableWidth : undefined,
                    boxSizing: 'border-box',
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTablePaperProps={compactEmbeddedModules ? {
                sx: {
                    width: 'fit-content',
                    maxWidth: 'fit-content',
                },
            } : undefined}
            muiTableContainerProps={{
                sx: {
                    width: tableWidth,
                    maxWidth: isModal ? '100%' : (compactEmbeddedModules ? embeddedTableWidth : undefined),
                    overflowX: isModal ? 'auto' : undefined,
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableProps={compactEmbeddedModules ? {
                sx: {
                    width: embeddedTableWidth,
                    tableLayout: 'fixed',
                },
            } : undefined}
            muiTableBodyCellProps={({column}) => ({
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": !isModal && {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        ...(compactEmbeddedModules ? {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minWidth: 0,
                        } : {}),
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            ...(compactEmbeddedModules ? {
                                display: 'block',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            } : {}),
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    },
                    ...(dependentModuleCompositionId ? dmcModalColSx(column.id) : {}),
                    ...(compactEmbeddedModules ? compactEmbeddedColSx(column.id, embeddedTableLayout?.colWidths) : {}),
                },
            })}
            muiTableHeadCellProps={({column}) => ({
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem",
                    ...((dependentModuleCompositionId || compactEmbeddedModules) ? {
                        ...(dependentModuleCompositionId ? dmcModalColSx(column.id) : compactEmbeddedColSx(column.id, embeddedTableLayout?.colWidths)),
                        whiteSpace: 'nowrap',
                        overflow: 'visible',
                        '& .Mui-TableHeadCell-Content': {
                            flexWrap: 'nowrap',
                        },
                        '& .Mui-TableHeadCell-Content-Labels, & .Mui-TableHeadCell-Content-Wrapper': {
                            overflow: 'visible',
                            textOverflow: 'clip',
                            whiteSpace: 'nowrap',
                            maxWidth: 'none',
                        },
                    } : {}),
                },
            })}
            muiTableBodyRowProps={({row}) => {
                return ({
                    onClick: () => isModal && setSelectedString(row.original),
                    sx: () => ({
                        height: '36px',
                        cursor: isModal && "pointer",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                            },
                        },
                        backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : "white",
                        "&:hover": {
                            backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: compactEmbeddedModules ? EMBEDDED_MODULE_ROW_ACTIONS_WIDTH : 3,
                    minSize: compactEmbeddedModules ? EMBEDDED_MODULE_ROW_ACTIONS_WIDTH : 3,
                    maxSize: compactEmbeddedModules ? EMBEDDED_MODULE_ROW_ACTIONS_WIDTH : undefined,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={filteredData}
            initialState={{
                sorting: dependentModuleCompositionId ? [{id: 'priority', desc: false}] : [],
            }}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            onGlobalFilterChange={(value) => {
                handleSearchQuery(value, data, null)
            }}
            onColumnFiltersChange={(updater) => {
                handleSearchQuery(updater(columnsFilter), data, null, true)
            }}
            onShowColumnFiltersChange={handleShowColumnFilters}
            state={{
                showColumnFilters: showColumnFilters,
                columnFilters: columnsFilter,
                globalFilter: globalFilter,
                showGlobalFilter: true,
                pagination: tableOptions,
            }}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={!isModal && menuItem.length > 0}
            enableColumnActions={!dependentModuleCompositionId}
            enableToolbarInternalActions={false}
        />
        {modal && <ModalModule
            title={currentEditRowData.id ? "Изменить" : "Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={(moduleId || dependentModuleCompositionId) ? handleSubmitDepend : currentEditRowData.id ? handleUpdate : handleSubmit}
            initValue={currentEditRowData}
            loading={loading}
            sideBaseModuleList={sideBaseModuleList}
            heightLocationModuleList={heightLocationModuleList}
            moduleId={dependentModuleCompositionId ? undefined : moduleId}
            dependentModuleCompositionId={dependentModuleCompositionId}
            compositionId={compositionId}
            handleModalAlert={handleModalAlert}
        />}
    </Box>);
}
export default ModulesTable